
import React, { ReactElement, useEffect, useState } from 'react'
import { Table } from 'antd'
import { Resizable } from 'react-resizable'
import '@/styles/resizableTable.less'
 
// 调整table表头
const ResizeableTitle = (props: any) => {
    const { onResize, width, ...restProps } = props
 
    if (!width) {
        return <th {...restProps} />
    }
 
    return (
        <Resizable
            width={width}
            height={0}
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} />
        </Resizable>
    )
}
 
// 拖拽调整table
const ResizeTable = (props: {
    tableData: any[]
    cols: any[]
    [property: string]: any
}): ReactElement => {
    // // table 数据
    // const dataSource = () => {
    //     const data: any[] = props.tableData
    //     return data
    // }
 
    // 表格列
    const [cols, setCols] = useState<any[]>([])
    const [columns, setColumns] = useState<any[]>([])
 
    // 定义头部组件
    const components = {
        header: {
            cell: ResizeableTitle,
        },
    }
 
    // 处理拖拽
    const handleResize = (index: number) => (e: any, { size }: any) => {
        const nextColumns: any = [...cols]
        // 拖拽是调整宽度
        nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
        }
 
        setCols(nextColumns)
    }
 
    useEffect(() => {
        setColumns((cols || []).map((col: any, index: number) => ({
            ...col,
            onHeaderCell: (column: any) => ({
                width: column.width,
                onResize: handleResize(index),
            }),
        })))
    }, [cols])

    useEffect(() => {
        setCols(props.cols)
    }, [props])
 
    return (
        <div className="components-table-resizable-column">
            <Table
                {...props}
                components={components}
                columns={columns}
                dataSource={props.tableData}
            />
        </div>
    )
}
 
export default ResizeTable